angular
    .module("skillBuilderSaaS")
    .directive("highlightOnChange", function () {
    return {
        link: function (_scope, element, attrs) {
            attrs.$observe("highlightOnChange", function (val) {
                if (val !== "") {
                    console.log("Highlighting", val);
                    element.effect("highlight", {}, 5000);
                }
            });
        }
    };
});
